import type { FC } from 'react';

import Box from '@mui/material/Box';

import TaskInfo from '@/views/apps/task/view/TaskInfo';
import type { EntityComponentProps } from '../../types/EntityComponent.types';

const TaskEntityContent: FC<EntityComponentProps> = ({ data }) => {
    return (
        <Box>
            <TaskInfo data={data} />
        </Box>
    );
};

export default TaskEntityContent;
